import { useTranslations } from 'next-intl';
import {
  Card,
  Button,
  Subline,
  LogoContainer,
  StarsContainer,
} from './Trustpilot.styles';

type Props = {
  className?: string;
  label: string;
  link: string;
  logo: string;
  numberOfReviews: number;
  stars: string;
  trustScore: number;
};

const Trustpilot = ({
  label,
  link,
  logo,
  numberOfReviews,
  stars,
  trustScore,
  className,
}: Props) => {
  const t = useTranslations('features.trustElements.trustpilot');

  const handleClick = () => {
    window.open(link, '_blank');
  };

  if (!logo || !stars) {
    return null;
  }

  return (
    <Card aria-label={t('label')} className={className}>
      <Button type="button" onClick={handleClick}>
        <LogoContainer
          dangerouslySetInnerHTML={{ __html: logo }}
          aria-hidden="true"
        />
        <StarsContainer
          dangerouslySetInnerHTML={{ __html: stars }}
          aria-hidden="true"
        />
        <Subline>
          <data value={trustScore}>
            {t('trustScore', { score: trustScore })}
          </data>{' '}
          | <strong>{t('reviews', { numberOfReviews })}</strong> | {label}
        </Subline>
      </Button>
    </Card>
  );
};

export { Trustpilot };
